
import { useState } from "react";
import { SessionsHeader } from "./components/SessionsHeader";
import { SessionsSearch } from "./components/SessionsSearch";
import { SessionsActions } from "./components/SessionsActions";
import { SessionsTable } from "./components/SessionsTable";
import { DeleteSessionDialog } from "./components/DeleteSessionDialog";
import { useTrainingSessions } from "./hooks/useTrainingSessions";

export const TrainingSessionsList = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [showStudentSessions, setShowStudentSessions] = useState(true);
  
  const {
    sessions,
    isLoading,
    sessionToDelete,
    deletingSession,
    handleDeleteClick,
    handleDeleteCancel,
    handleDelete
  } = useTrainingSessions(showStudentSessions);

  // Filter sessions based on search term
  const filteredSessions = sessions?.filter((session) =>
    `${session.student?.first_name} ${session.student?.last_name}`
      .toLowerCase()
      .includes(searchTerm.toLowerCase())
  );

  return (
    <div className="space-y-4 animate-fade-in">
      <SessionsHeader />

      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
        <SessionsSearch 
          searchTerm={searchTerm} 
          setSearchTerm={setSearchTerm} 
          showStudentSessions={showStudentSessions}
          setShowStudentSessions={setShowStudentSessions}
        />
        
        <SessionsActions />
      </div>

      {isLoading ? (
        <div className="text-center py-4 bg-white/80 dark:bg-gray-800/80 rounded-xl shadow-sm border border-slate-100/50 dark:border-gray-700/50 backdrop-blur-sm">
          <div className="animate-pulse flex flex-col items-center">
            <div className="h-4 w-24 bg-slate-200 dark:bg-gray-600 rounded mb-3"></div>
            <div className="h-2 w-16 bg-slate-100 dark:bg-gray-700 rounded"></div>
          </div>
        </div>
      ) : (
        <SessionsTable 
          sessions={filteredSessions || []} 
          onDeleteSession={handleDeleteClick} 
        />
      )}

      <DeleteSessionDialog 
        isOpen={!!sessionToDelete}
        onClose={handleDeleteCancel}
        onConfirm={handleDelete}
        isDeleting={deletingSession}
      />
    </div>
  );
};
